import Styles from './index.module.scss';
import TextBox from "../../shared/elements/textbox";
import Button from "../../shared/elements/button";
import i18n from '../../../utils/translations/i18n';
import { useState } from 'react';
import ErrorBar from '../../shared/elements/errorBar';

const ForgotPasswordForm = ({ form, handleSubmit, errorBarState, handleChange, handleBlur }) => {
    const { t } = i18n;
    
    return (
        <form className={Styles.form}>
            <div className={Styles.header}>
                <h2 className={Styles.title}>{t('sign_in.forgot_password')}</h2>
            </div>
            <div><span className={Styles.subtitle}>{t('reset_password.rcvResetLink')}</span></div>
            {errorBarState.isActive && <div className={Styles.errorContainer}>
                    <ErrorBar message={errorBarState.message}/>
            </div>}
            {form.formFields.map(field => {
                return (<TextBox
                    key={form[field].id}
                    id={form[field].id}
                    className={form[field].className}
                    name={form[field].name}
                    type={form[field].type}
                    max={form[field].maxLength}
                    label={form[field].label}
                    placeholder={form[field].label}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isRequired={form[field].required}
                    value={form[field].value}
                    dangerWarn={form[field].dangerWarn}
                    errorMessage={form[field].errorMessage}
                ></TextBox>)
            })}
            <Button id="submit-button" type="submit" onClick={handleSubmit} subClass="btn--pill" className={Styles.submitButton}>
                {t('reset_password.submit')}
            </Button>
        </form>
    )
}

export default ForgotPasswordForm;
